import { getResultDisplaySettings, saveResultDisplaySettings } from "../../api/result";
import apiProcess from "../../api/utility";
import debounce from "../../helper/debounceFn";

class ResultOperation {
  constructor() {
    this.operation = new Map() // verificationId - setting
  }

  getSettings = async (id) => {
    try {
      const setting = await getResultSettings(id);
      this.operation.set(id, setting);
      return setting
    } catch (e) {
      console.error(e)
    }
  }

  saveSettings = async (id) => {
    try {
      const setting = this.operation.get(id)
      if(setting) {
        await saveResultSettings(id, setting)
      }
    } catch (e) {
      console.error(e)
    }
  }

  setOperation = (id, setting) => {
    this.operation.set(id, setting);
  }

  getOperation = (id) => {
    const setting = this.operation.get(id);
    return setting
  }

  setOperationByKey = (id, key, setting) => {
    const oldSetting = this.operation.get(id) || {};
    this.operation.set(id, { ...oldSetting, [key]: setting })
    debounce(() => {
      this.saveSettings(id)
    }, 1000, false, 'result-setting')()
  }

  getOperationByKey = (id, key) => {
    const setting = this.operation.get(id) || {};
    return setting[key]
  }
}

function getResultSettings(verificationId) {
  return apiProcess(getResultDisplaySettings, verificationId);
}

function saveResultSettings(verificationId, setting) {
  return apiProcess(saveResultDisplaySettings, { verificationId, setting })
}

const resultOperation = new ResultOperation();
export default resultOperation;